/**
 * The Sun's orbit around the galaxy centre; the card shows these with "about".
 * distanceLy: NASA/JPL Spitzer release (2006), "located 26,000 light-years away".
 * periodYears and speedKmS: NASA Science "Our Sun: Facts", about 230 million years and
 * an average 720,000 km/h, which is 200 km/s.
 */
export const SUN_GALACTIC_ORBIT = {
  distanceLy: 26_000,
  periodYears: 230e6,
  speedKmS: 200,
} as const;
